import TextLink from 'LuxKit/TextLink'
import TourTermsAndConditionsModal from 'components/OfferPage/TourV2/TourTermsAndConditionsModal'
import { getTourCampaignTourTermsAndConditions, tourCampaignFlightCreditInclusionMessage } from 'constants/tours'
import ModalContext from 'contexts/ModalContext'
import type { MouseEvent } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'

function TourCampaignFlightCreditDescription() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  // Rows sit inside clickable tiles, so the link must not trigger the tile.
  const openTermsAndConditionsModal = useCallback((event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<TourTermsAndConditionsModal termsAndConditions={getTourCampaignTourTermsAndConditions(intl)} />)
  }, [showModal, intl])

  const renderTermsLink = useCallback(
    (chunks: React.ReactNode) => <TextLink key="terms-link" onClick={openTermsAndConditionsModal}>{chunks}</TextLink>,
    [openTermsAndConditionsModal],
  )

  return <>{intl.formatMessage(tourCampaignFlightCreditInclusionMessage, { link: renderTermsLink })}</>
}

export default TourCampaignFlightCreditDescription
